// thunks.ts
//
// (c) NCR Voyix Corporation 2025. All rights reserved.

import { createAsyncThunk } from '@reduxjs/toolkit'
import { buildAuthenticatedUser } from '../../common/authenticatedUser'
import {
  deleteSavedSolutionSet,
  fetchAvailableNCRSolutionSets, fetchSavedSolutionSets, SolutionSet, updateSavedSolutionSets
} from '../../data/solutionSet'

export const getAvailableNCRSolutionSets = createAsyncThunk(
  'solutionSets/getAvailableNCRSolutionSets',
  async (args: {
    dataCenter: string
    sessionId: string
    userId: string
    companyId: string
  }) => {
    const {
      dataCenter, sessionId, userId, companyId
    } = args
    const authUser = buildAuthenticatedUser(sessionId, dataCenter, userId)

    return fetchAvailableNCRSolutionSets(
      authUser,
      companyId
    )
  }
)

export const getAvailableSavedSolutionSets = createAsyncThunk(
  'solutionSets/getAvailableSavedSolutionSets',
  async (args: {
    sessionId: string
    dataCenter: string
    userId: string
    companyId: string
  }) => {
    const {
      sessionId, dataCenter, userId, companyId
    } = args
    const authUser = buildAuthenticatedUser(sessionId, dataCenter, userId)

    return fetchSavedSolutionSets(
      authUser,
      companyId
    )
  }
)

export const saveSolutionSet = createAsyncThunk(
  'solutionSets/saveSolutionSet',
  async (args: {
    solutionSet: SolutionSet
    dataCenter: string
    companyId: string
    sessionId: string
    userId: string
  }, { dispatch }) => {
    const {
      solutionSet, dataCenter, companyId, sessionId, userId
    } = args
    const authUser = buildAuthenticatedUser(sessionId, dataCenter, userId)
    const response = await updateSavedSolutionSets(solutionSet, authUser, companyId)
    await dispatch(getAvailableSavedSolutionSets({
      sessionId,
      dataCenter,
      userId,
      companyId
    }))
    return response
  }
)

export const removeSavedSolutionSet = createAsyncThunk(
  'solutionSets/removeSavedSolutionSet',
  async (args: {
    solutionSet: SolutionSet
    dataCenter: string
    companyId: string
    sessionId: string
    userId: string
  }, { dispatch }) => {
    const {
      solutionSet, dataCenter, companyId, sessionId, userId
    } = args
    const authUser = buildAuthenticatedUser(sessionId, dataCenter, userId)
    const response = await deleteSavedSolutionSet(solutionSet, authUser, companyId)
    await dispatch(getAvailableSavedSolutionSets({
      sessionId,
      dataCenter,
      userId,
      companyId
    }))
    return response
  }
)
